<template>
	<b-container class="set-block-details-container">
		<b-row v-if="!$store.getters.userHasRole('system_admin')">
			<b-col sm="7" lg="12">
				<div class="mb-3">
<!-- 				You do not have access to this. -->
			</div>
			</b-col>
		</b-row>
		<b-row v-if="$store.getters.userHasRole('system_admin')">
			<b-col sm="7" lg="12">
				<div v-if="block" class="mb-3">
					<h2>ID:{{block.blockId}} {{block.streetName}} between {{block.fromStreet}} and {{block.toStreet}} <b-button type="button" class="mt-2" @click="zoomToBlockId(block.blockId)">Zoom</b-button>
					</h2>
					<b-form-group label="Direction">
						<b-form-select v-model="block.directionId" :options="LaneClosureRequest.getDirectionIdOptions"
						value-field="id"
						text-field="name"
						inline
						></b-form-select>
					</b-form-group>


					<b-form-group v-if="block.directionId == 3 || block.directionId == 5">
						<b-input-group prepend="Eastbound Left">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundLeft"
								:options="blockLeftTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundLeft"/>

						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5">
						<b-input-group prepend="Eastbound Right">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundRight"
								:options="blockRightTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundRight"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5">
						<b-input-group prepend="Eastbound Through">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundThrough"
								:options="blockThroughOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundThrough"/>

						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5">
						<b-input-group prepend="Eastbound Bicycle Lane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundBicycleLaneId"
								:options="LaneClosureRequest.getEastboundBicycleLaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5">
						<b-input-group prepend="Eastbound Left Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundLeftBacklane"
								:options="blockLeftBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundLeftBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5">
						<b-input-group prepend="Eastbound Right Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundRightBacklane"
								:options="blockRightBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundRightBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5" class="bfg-eb-lat">
						<b-input-group prepend="Eastbound Latitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundLat"
								:options="latOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundLat"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 3 || block.directionId == 5"  class="bfg-eb-long">
						<b-input-group prepend="Eastbound Longitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.eastboundLon"
								:options="lonOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.eastboundLon"/>
						</b-input-group>
					</b-form-group>

					<!--  ================================================================================================================================================================ -->

					<b-form-group v-if="block.directionId == 4 || block.directionId == 5">
						<b-input-group prepend="Westbound Left">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundLeft"
								:options="blockLeftTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundLeft"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 4 || block.directionId == 5">
						<b-input-group prepend="Westbound Right">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundRight"
								:options="blockRightTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundRight"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 4 || block.directionId == 5">
						<b-input-group prepend="Westbound Through">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundThrough"
								:options="blockThroughOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundThrough"/>

						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 4 || block.directionId == 5">
						<b-input-group prepend="Westbound Bicycle Lane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundBicycleLaneId"
								:options="LaneClosureRequest.getWestboundBicycleLaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 4 || block.directionId == 5">
						<b-input-group prepend="Westbound Left Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundLeftBacklane"
								:options="blockLeftBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundLeftBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 4 || block.directionId == 5">
						<b-input-group prepend="Westbound Right Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundRightBacklane"
								:options="blockRightBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundRightBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>

					<b-form-group v-if="block.directionId == 4 || block.directionId == 5"  class="bfg-wb-lat">
						<b-input-group prepend="Westbound Latitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundLat"
								:options="latOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundLat"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 4 || block.directionId == 5" class="bfg-wb-long">
						<b-input-group prepend="Westbound Longitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.westboundLon"
								:options="lonOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.westboundLon"/>
						</b-input-group>
					</b-form-group>

					<!--  ================================================================================================================================================================ -->

					<b-form-group v-if="block.directionId == 2 || block.directionId == 6">
						<b-input-group prepend="Southbound Left">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundLeft"
								:options="blockLeftTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundLeft"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 2 || block.directionId == 6">
						<b-input-group prepend="Southbound Right">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundRight"
								:options="blockRightTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundRight"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 2 || block.directionId == 6">
						<b-input-group prepend="Southbound Through">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundThrough"
								:options="blockThroughOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundThrough"/>

						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 2 || block.directionId == 6">
						<b-input-group prepend="Southbound Bicycle Lane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundBicycleLaneId"
								:options="LaneClosureRequest.getSouthboundBicycleLaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 2 || block.directionId == 6">
						<b-input-group prepend="Southbound Left Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundLeftBacklane"
								:options="blockLeftBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundLeftBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 2 || block.directionId == 6">
						<b-input-group prepend="Southbound Right Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundRightBacklane"
								:options="blockRightBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundRightBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>

					<b-form-group v-if="block.directionId == 2 || block.directionId == 6" class="bfg-sb-lat">
						<b-input-group prepend="Southbound Latitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundLat"
								:options="latOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundLat"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 2 || block.directionId == 6" class="bfg-sb-long">
						<b-input-group prepend="Southbound Longitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.southboundLon"
								:options="lonOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.southboundLon"/>
						</b-input-group>
					</b-form-group>

					<!--  ================================================================================================================================================================ -->

					<b-form-group v-if="block.directionId == 1 || block.directionId == 6">
						<b-input-group prepend="Northbound Left">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundLeft"
								:options="blockLeftTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundLeft"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 1 || block.directionId == 6">
						<b-input-group prepend="Northbound Right">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundRight"
								:options="blockRightTurnOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundRight"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 1 || block.directionId == 6">
						<b-input-group prepend="Northbound Through">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundThrough"
								:options="blockThroughOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundThrough"/>

						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 1 || block.directionId == 6">
						<b-input-group prepend="Northbound Bicycle Lane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundBicycleLaneId"
								:options="LaneClosureRequest.getNorthboundBicycleLaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 1 || block.directionId == 6">
						<b-input-group prepend="Northbound Left Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundLeftBacklane"
								:options="blockLeftBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundLeftBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 1 || block.directionId == 6">
						<b-input-group prepend="Northbound Right Backlane">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundRightBacklane"
								:options="blockRightBacklaneOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundRightBacklane" type="number" min="0"/>
						</b-input-group>
					</b-form-group>

					<b-form-group v-if="block.directionId == 1 || block.directionId == 6" class="bfg-nb-lat">
						<b-input-group prepend="Northbound Latitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundLat"
								:options="latOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundLat"/>
						</b-input-group>
					</b-form-group>
					<b-form-group v-if="block.directionId == 1 || block.directionId == 6" class="bfg-nb-long">
						<b-input-group prepend="Northbound Longitude">
							<b-input-group-append>
								<b-form-radio-group
								v-model="block.northboundLon"
								:options="lonOptions"
								buttons
								button-variant="outline-primary"
								name="radio-btn-outline"
								value-field="id"
								text-field="name"
								inline
								></b-form-radio-group>
							</b-input-group-append>
							<b-input v-model="block.northboundLon"/>
						</b-input-group>
					</b-form-group>
					<b-button variant="primary" @click="onSaveBlockDetails">Save <b-spinner small label="Saving..." class="ml-2" v-if="isSaving"></b-spinner></b-button>

					<div v-show="polyline != null && 1 == 2">
						{{showHeading}}
						{{polyline.i}}
					</div>


				</div>


				<div class="bg-primary-x-light p-3">
					<h2>Find Street Blocks</h2>
					<div class="row">
					<div class="col col-3">

				<b-form-group label="Only Streets Without Directions Set">
					<b-form-radio-group inline  @change="onStreetSearch(streetText)"  id="rg-withoutDirections" :options="LaneClosureRequest.getYesNoOptions" value-field="id" text-field="name" v-model="withoutDirection"></b-form-radio-group>
				</b-form-group>
					</div>
				<div class="col col-3">
				<b-form-group label="Only Regional Streets">
					<b-form-radio-group @change="onStreetSearch(streetText)" inline id="rg-includeLocalStreets" :options="LaneClosureRequest.getYesNoOptions" value-field="id" text-field="name" v-model="hideLocalStreets"></b-form-radio-group>
				</b-form-group>
				</div>
				</div>
				<div class="row">
					<div class="col col-md-6">
				<b-form-group id="ig-select-street" label="Street Name (% to list all)" label-for="input-lcr-regional-streets" description="" :state="street.status" :invalid-feedback="street.invalidMessage" inline>

							<multiselect
							class="custom-multiselect"
							ref="affectedStreetFilterAdd"
							v-model="streetText"
							track-by="id"
							open-direction="bottom"
							label="label"
							:options="streets"
							:show-labels="false"
							:multiple="false"
							:close-on-select="true"
							:hide-selected="false"
							:preserve-search="false"
							:clear-on-select="false"
							:internal-search="false"
							placeholder="Select or start typing"
							:loading="loadingStreets"
							@search-change="onStreetSearch"
							@input="onStreetInput"
							>
							<template slot="selection" slot-scope="{ values, search, isOpen }">
								<span
								class="multiselect__single"
								v-if="values.length && !isOpen"
								v-html="getOptionSelected(values.length)"
								></span>

							</template>
							<template slot="option" slot-scope="props">
								<div class="option__desc">
									<span class="option__title">{{ props.option.label }}</span><br>
								</div>
							</template>
							<template slot="noOptions">
							</template>
							<template slot="afterList">
								<li class="multiselect__after-list">Start typing to find streets.</li>
							</template>

							<template slot="noResult">
								No results. Please try changing the search query.
							</template>
						</multiselect>
						<div v-if="street.value" class="value-affected-street">{{street.value}}<br/><b-button type="button" class="mb-3" @click="getBlockByStreetName(street.value)">Reload {{street.value}} Blocks</b-button>  <span style="padding-left:20px;">{{streetCount}} Streets in Search</span></div>
				</b-form-group>

				</div>
				</div>

				<div class="show-on-map-wrapper">
					<a class="show-on-map text-left" @click="showOnMap">
						<span class="on-container">
							<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
							<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
						</span>
					</a>
				</div>

				<div class="row">
					<div class="col col-md-4">
				<b-form-group label="Default direction when clicking on block without direction">
				<b-form-select v-model="directionId.value" :options="LaneClosureRequest.getDirectionIdOptions"
				@input="directionId.resetStatus()"
				:state="directionId.status"
				value-field="id"
				text-field="name"
				inline
				></b-form-select>
				</b-form-group>
				</div>
				</div>
				<b-form-group label="Street Block Line Colours">
					<template v-if="showFixMediansColours">
					<div class="legend-line" style="border-color: #23f0ff;border-top: 4px solid #23f0ff;position: relative;top: -5px;width: 25px;display:inline-block;"></div> Different Street Names
					<div class="legend-line" style="border-color: #ffcc23;border-top: 4px solid #ffcc23;position: relative;top: -5px;width: 25px;display:inline-block;"></div> No turns
					<div class="legend-line" style="border-color: #ff238a;border-top: 4px solid #ff238a;position: relative;top: -5px;width: 25px;display:inline-block;"></div> Turns
					<div class="legend-line" style="border-color: #000000;border-top: 4px solid #000000;position: relative;top: -5px;width: 25px;display:inline-block;"></div> No Direction
					</template>
					<template v-else>
					<div class="legend-line" style="border-color: #000000;border-top: 4px solid #000000;position: relative;top: -5px;width: 25px;display:inline-block;"></div> No Direction Set
					<div class="legend-line" style="border-color: #23D47B;border-top: 4px solid #23D47B;position: relative;top: -5px;width: 25px;display:inline-block;"></div> Westbound
					<div class="legend-line" style="border-color: #D4237B;border-top: 4px solid #D4237B;position: relative;top: -5px;width: 25px;display:inline-block;"></div> EastBound
					<div class="legend-line" style="border-color: #0000FF;border-top: 4px solid #0000FF;position: relative;top: -5px;width: 25px;display:inline-block;"></div> EastBound & Westbound
					<div class="legend-line" style="border-color: #237BD4;border-top: 4px solid #237BD4;position: relative;top: -5px;width: 25px;display:inline-block;"></div> Northbound
					<div class="legend-line" style="border-color: #DB8024;border-top: 4px solid #DB8024;position: relative;top: -5px;width: 25px;display:inline-block;"></div> Southbound
					<div class="legend-line" style="border-color: #FF0000;border-top: 4px solid #FF0000;position: relative;top: -5px;width: 25px;display:inline-block;"></div> Northbound & Southbound
					</template>

					<b-form-radio-group v-show="false" id="rg-dczTemporaryTcRemoved" @change="toggleColours()" :options="LaneClosureRequest.getYesNoOptions" value-field="id" text-field="name" v-model="showFixMediansColours"></b-form-radio-group>
				</b-form-group>
				<!-- <b-button @click="LoadAllBlocks()">Load all Regional Street Blocks (SLOW!)</b-button> -->
				<b-spinner small label="Loading..." class="ml-2" v-if="loadingBlocks">Loading Street Blocks</b-spinner>
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
import LaneClosureRequest from '../../../models/LaneClosureRequest';
import BootstrapField from '../../../utility/BootstrapField';
import { gmapApi } from 'gmap-vue'
import KMLHelper from '../../../utility/KMLHelper';
// import createBlockMarker from "../../../utility/BlockMarker.js";

import Vue from 'vue'


export default {
	name: 'SetBlockDirections',

	components: {
	},

	data() {
		return {
			loadingStreets:false,
			directionId: new BootstrapField(
			{value:null}
			),
			street: new BootstrapField(
			{value:null}
			),
			streetCount: 0,
			streetText:null,
			loadingBlocks: false,
			map: null,
			isSaving: false,
			LaneClosureRequest,
			submitted: null,
			block:null,
			showFixMediansColours:0,
			polyline:null,
			saveState: null,
			showStreets: false,
			withoutDirection:1,
			hideLocalStreets:1,
			searchText:"",
			streets:[],
		}
	},
	mounted() {
		this.setEventBusOn();
		this.$nextTick(() => {
			Vue.prototype.$bus.$emit("map:shown", 1);
		})
	},
	computed: {
		googleMapApi: gmapApi,
		blockLeftTurnOptions() {
			let items = [];
			items.push({id:null, name:"No Left Turn"});
			items.push({id:this.block.toStreet, name:this.block.toStreet});
			items.push({id:this.block.fromStreet, name:this.block.fromStreet});
			items.push({id:this.block.streetName, name:this.block.streetName});
			return items;
		},
		blockRightTurnOptions() {
			let items = [];
			items.push({id:null, name:"No Right Turn"});
			items.push({id:this.block.toStreet, name:this.block.toStreet});
			items.push({id:this.block.fromStreet, name:this.block.fromStreet});
			items.push({id:this.block.streetName, name:this.block.streetName});
			return items;
		},
		blockThroughOptions() {
			let items = [];
			items.push({id:this.block.streetName, name:this.block.streetName});
			items.push({id:null, name:"No Through"});
			items.push({id:this.block.toStreet, name:this.block.toStreet});
			items.push({id:this.block.fromStreet, name:this.block.fromStreet});
			return items;
		},
		blockLeftBacklaneOptions() {
			let items = [];
			items.push({id:0, name:"Zero Left Turn Backlanes"});
			items.push({id:1, name:"One Left Turn Backlane"});
			return items;
		},
		blockRightBacklaneOptions() {
			let items = [];
			items.push({id:0, name:"Zero Right Turn Backlanes"});
			items.push({id:1, name:"One Right Turn Backlane"});
			return items;
		},
		latOptions() {
			let items = [];
			if (this.polyline) {
				let x = 0;
				for (x = 0; x < this.polyline.length;x++) {
					items.push({id:this.polyline.getAt(x).lat(), name:""+x});
				}
			}
			return items;
		},
		lonOptions() {
			let items = [];
			if (this.polyline) {
				let x = 0;
				for (x = 0; x < this.polyline.length;x++) {
					items.push({id:this.polyline.getAt(x).lng(), name:""+x});
				}
			}
			return items;
		},
		showHeading() {
			var heading = 0;
			if (this.polyline) {
				heading = google.maps.geometry.spherical.computeHeading(this.polyline.getAt(0), this.polyline.getAt(this.polyline.length-1));
			}
			return heading;
		}
	},
	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		toggleColours() {
			this.getBlockByStreetName(this.street.value);
		},
		// toggleColours() {
		// 	this.getBlockByStreetName(this.street.value);
		// },
		// toggleColours() {
		// 	this.getBlockByStreetName(this.street.value);
		// },


		showOnMap() {
			// Vue.prototype.$bus.$emit("map:toggleSideMap");
			Vue.prototype.$bus.$emit("map:toggle");
		},
		setEventBusOff() {
			this.$bus.$off('map:edit-block-details', this.onEditBlockDetails);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('map:edit-block-details', this.onEditBlockDetails);
		},

		zoomAllBlocks() {
			this.$store.dispatch("map/zoomAllBlocks", null);
		},
		zoomToBlockId(id) {
			this.$store.dispatch("map/zoomToBlockId", id);
		},

		setPolylineColours(index) {
			let x = 0;
			for (x =0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == this.value[index].blockId) {
							this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#293C7C'});
						} else {
							this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#666666'});
						}
					}
				}
			}
		},



		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			let x = 0;
			if (block) {
				// find the existing marker/placemark.
				if (that.$store.getters["map/polylines"]) {
					for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
						if (that.$store.getters["map/polylines"][x]) {
							if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
								blockPolyline = that.$store.getters["map/polylines"][x];
								foundIndex = x;
							}
						}
					}
				}
				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({
						map: null,
						afterParse: function(doc) {
							let color = "#000000";
							let opacity = 1.0;
							let weight = 8;
							let xx = 0;
							var coords = [];
							let zz = 0;
							for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
								for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
									coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
								}
							}
							let mapPolyline = new google.maps.Polyline({
								map: that.$store.state.map.map,
								path: coords,
								strokeColor: color,
								strokeOpacity: opacity,
								strokeWeight: weight
							});
							mapPolyline.blockData = block;
							let mapIndex = -1;
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
											mapIndex = x;
										}
									}
								}
							}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
								if (that.showFixMediansColours == true) {
									that.$store.dispatch("map/setPolylineStyleForFixingMedianTurns", that.$store.getters["map/polylines"].length-1);
								} else {
									that.$store.dispatch("map/setPolylineStyleForDirections", that.$store.getters["map/polylines"].length-1);
								}
							} else {
								if (that.showFixMediansColours == true) {
									that.$store.dispatch("map/setPolylineStyleForFixingMedianTurns", mapIndex);
								} else {
									that.$store.dispatch("map/setPolylineStyleForDirections", mapIndex);
								}
							}
							google.maps.event.addListener(mapPolyline, 'click', function() {
								that.$bus.$emit('map:edit-block-details', this.blockData);
							});
							return;
						}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				} else {
					if (that.showFixMediansColours == true) {
						that.$store.dispatch("map/setPolylineStyleForFixingMedianTurns", foundIndex);
					} else {
						that.$store.dispatch("map/setPolylineStyleForDirections", foundIndex);
					}
				}
			}
		},


		onSaveBlockDetails(blockId) {
			this.isSaving = true;
			let that = this;
			let obj = {
				blockId:this.block.blockId,
				directionId:this.block.directionId,
				eastboundBicycleLaneId:this.block.eastboundBicycleLaneId,
				eastboundLat:this.block.eastboundLat,
				eastboundLeft:this.block.eastboundLeft,
				eastboundLeftBacklane:this.block.eastboundLeftBacklane,
				eastboundLon:this.block.eastboundLon,
				eastboundRight:this.block.eastboundRight,
				eastboundRightBacklane:this.block.eastboundRightBacklane,
				eastboundThrough:this.block.eastboundThrough,
				fromStreet:this.block.fromStreet,
				kml:this.block.kml,
				northboundBicycleLaneId:this.block.northboundBicycleLaneId,
				northboundLat:this.block.northboundLat,
				northboundLeft:this.block.northboundLeft,
				northboundLeftBacklane:this.block.northboundLeftBacklane,
				northboundLon:this.block.northboundLon,
				northboundRight:this.block.northboundRight,
				northboundRightBacklane:this.block.northboundRightBacklane,
				northboundThrough:this.block.northboundThrough,
				sRoute:this.block.sRoute,
				southboundBicycleLaneId:this.block.southboundBicycleLaneId,
				southboundLat:this.block.southboundLat,
				southboundLeft:this.block.southboundLeft,
				southboundLeftBacklane:this.block.southboundLeftBacklane,
				southboundLon:this.block.southboundLon,
				southboundRight:this.block.southboundRight,
				southboundRightBacklane:this.block.southboundRightBacklane,
				southboundThrough:this.block.southboundThrough,
				streetName:this.block.streetName,
				toStreet:this.block.toStreet,
				westboundBicycleLaneId:this.block.westboundBicycleLaneId,
				westboundLat:this.block.westboundLat,
				westboundLeft:this.block.westboundLeft,
				westboundLeftBacklane:this.block.westboundLeftBacklane,
				westboundLon:this.block.westboundLon,
				westboundRight:this.block.westboundRight,
				westboundRightBacklane:this.block.westboundRightBacklane,
				westboundThrough:this.block.westboundThrough,
			}
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/set-details', obj)
			.then(resp => {
					/*
					let foundIndex = null;
					let x = 0;
					let block = resp.data[0];
					if (that.$store.getters["map/polylines"]) {
						for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
							if (that.$store.getters["map/polylines"][x]) {
								if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
									foundIndex = x;
									that.$store.getters["map/polylines"][x].blockData.directionId = that.directionId.value;
									that.$store.dispatch("map/setPolylineStyleForDirections", foundIndex);
								}
							}
						}
					}
					if (foundIndex == null) {
						// that.setBlockPolyline(block);
					} else {
						// that.$store.commit("map/setPolylineBlockDataByIndex", foundIndex, block);
					}
					*/
				that.isSaving = false;

				})
			.catch(error => {
				that.isSaving = false;

			})
		},


		onEditBlockDetails(block) {
			this.block = block;
			if ((block.directionId == null || block.directionId == 0) && this.directionId.getRawValue() != null) {
				block.directionId = this.directionId.getRawValue();
			}


			let that = this;
			let foundIndex = null;
			let x = 0;
			if (this.$store.getters["map/polylines"]) {
				for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
					if (this.$store.getters["map/polylines"][x]) {
						if (this.$store.getters["map/polylines"][x].blockData) {
							if (this.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
								foundIndex = x;
								that.polyline = this.$store.getters["map/polylines"][foundIndex].getPath();
								this.$nextTick(() => {
									let obj = this.$store.getters["map/polylines"][foundIndex];
									obj.setOptions({strokeColor:'#000000'});
									obj.setOptions({strokeOpacity: 0.5});

									this.$store.commit("map/clearMarkers");

									let path = obj.getPath();
									let x = 0;
									for (x = 0; x < path.length; x++) {
										let marker = new google.maps.Marker({
											position:  new google.maps.LatLng(path.getAt(x).lat(), path.getAt(x).lng()),
											map: that.$store.state.map.map,
											title: ''+x,
											label: ''+x
										});
										this.$store.commit("map/addMarker", marker);
									}
								});

							} else {
									// let obj = this.$store.getters["map/polylines"][x];
									// obj.setOptions({strokeColor:'#cccccc'});
									if (this.showFixMediansColours == true) {
										this.$store.dispatch("map/setPolylineStyleForFixingMedianTurns", x);
									} else {
										this.$store.dispatch("map/setPolylineStyleForDirections", x);
									}
								}
							}
						}
					}
				}


			},


			getBlockByStreetName(street) {
				this.loadingBlocks = true;
				this.$store.commit("map/clearBlockDetailerMap", null);
				let that = this;
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/block/regional-street-blocks?q=' + encodeURI(street))
				.then(resp => {
					if (resp.data.length > 0) {
						let x = 0;
						for (x = 0; x < resp.data.length; x++) {
							that.setBlockPolyline(resp.data[x]);
						}
					}
					this.loadingBlocks = false;
					this.zoomAllBlocks();
				})
				.catch(error => {
				})
			},

			// Updates the most recent text entered into the autocomplete input.
			getDirectionlessBlocks(local) {
				return new Promise((resolve, reject) => {
					Vue.prototype.$http.get(this.$store.state.apiUrl + '/block/streets-without-direction?local=' + local)
					.then(resp => {
						this.streetCount = resp.data.length;
						this.streets =  resp.data;
						this.showStreets = true;
					})
					.catch(error => {
						reject(error)
					})
				})
			},

			listAgain() {
				// this.$refs.findStreet.setValue("%");
				// console.log(this.$refs.findStreet);
				this.$refs.findStreet.$refs.input.value = this.searchText;
				// this.$refs.findStreet.results = this.streets;
				this.$refs.findStreet.$refs.input.blur();
				this.$refs.findStreet.$refs.input.focus();
				// this.$refs.findStreet.handleShow();
				// this.$refs.findStreet.search("%");
			},

		// Updates the most recent text entered into the autocomplete input.
		SearchStreet(input) {
			var val = "";
			if (input == null) {
				return;
			}
			if (typeof input == "object") {
				val = input.id;
			} else {
				val = input;
			}

			return new Promise((resolve, reject) => {
				if (val.length < 1 && val != "%") {
					return resolve([])
				}
				this.searchText = val;
				let url = this.$store.state.apiUrl + '/block/find-regional-street?q=' + encodeURI(val);
				if (this.withoutDirection) {
					url += "&withoutDirection=1";
				}
				if (this.hideLocalStreets) {
					url += "&hideLocalStreets=1";
				}

				Vue.prototype.$http.get(url)
				.then(resp => {
					this.streetCount = resp.data.length;
					this.streets = resp.data;
					resolve(resp.data)
					Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
				})
				.catch(error => {
					reject(error)
				})
			})
		},


		onStreetInput(value, instance) {
			if (value == null) {
				return;
			}
			this.getBlockByStreetName(value.id);
		},


		// Updates the most recent text entered into the autocomplete input.
		onStreetSearch(input) {
			if (input == null) {
				return;
			}
			let that = this;
			var val = "";
			if (typeof input == "object") {
				val = input.id;
			} else {
				val = input;
			}
				if (val == null) {
					return;
				}
				if (val.length < 1 && val != "%") {
					return;
				}
				this.loadingStreets = true;
				this.searchText = val;
				let url = this.$store.state.apiUrl + '/block/find-regional-street?q=' + encodeURI(val);
				if (this.withoutDirection) {
					url += "&withoutDirection=1";
				}
				if (this.hideLocalStreets) {
					url += "&hideLocalStreets=1";
				}
				Vue.prototype.$http.get(url)
				.then(resp => {
					that.streetCount = resp.data.length;
					that.streets = [];
					var item = {};

					for (var x = 0; x < resp.data.length; x++) {
						item = {
							id: `${resp.data[x].streetName}`,
							label: `${resp.data[x].streetName}`,
						}
						that.streets.push(item);
					}
					that.loadingStreets = false;
					Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
				})
				.catch(error => {
				})
		},



		SearchStreetValue(result) {
			return result.streetName
		},

		HandleSelectStreet(selected) {
			this.street.value = selected.streetName;
			this.block = null;
			this.getBlockByStreetName(selected.streetName);
		},

		LoadAllBlocks() {
			this.street.value = "%";
			this.block = null;
			this.getBlockByStreetName("%");
		}


	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
		});
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit("map/clearBlockDetailerMap", null);
		this.setEventBusOff();
		next(true);
	},
}
</script>
<i18n>
{
	"en-CA": {
	}
}
</i18n>